export type ServerHeaderCollector = {
  addHeader: (value: string) => void
  getHeader: () => string | undefined
}

export const createServerHeaderCollector = (): ServerHeaderCollector => {
  const headerEntries: string[] = []

  const addHeader = (value: string) => {
    headerEntries.push(value)
  }

  const getHeader = (): string | undefined => {
    if (headerEntries.length === 0) return undefined
    return headerEntries.join(', ')
  }

  return { addHeader, getHeader }
}
